<template>
    <v-container class="pa-2 ma-2">
        <v-card color="#FFD375" flat :width="width">
            <v-row>
                <v-col cols="3">
                    <v-list-item-title class="boldtext">Name</v-list-item-title>
                </v-col>
                <v-col cols="9">
                    <v-text-field name="name" v-model="name" @change="changeHandler(1)" required></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="3">
                    <v-list-item-title class="boldtext">Tag</v-list-item-title>
                </v-col>
                <v-col cols="9">
                    <v-text-field name="tag" v-model="tag" @change="changeHandler(2)" required></v-text-field>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
    import firebase from 'firebase';
    import { callcloudfunction } from '@/functions.js';

    export default {
        mounted: function () {
            this.name = this.$store.state.currentuser.Name;
            this.tag = this.$store.state.currentuser.Tag;
            this.oktag = this.tag;
        },
        data: () => ({
            name: "",
            tag: "",
            oktag:"",
            width: "400px",
        }),
        components: {
        },
        methods: {
            changeHandler(v) {
                if (v == 1) {
                    firebase.database().ref('usercore/' + this.$store.state.user.uid + '/Name').set(this.name);
                }
                if (v == 2) {
                    callcloudfunction("checkTag", "full", { tagletters: this.tag }, this, "");  
                }
            },
            cloudReturn(v) {
                alert("cloudReturn " + v);
                var arr = v.split(',');
                if ((arr[1] === "exists") && (this.oktag != this.tag)) {
                    this.$root.alertm('Alert', this.tag + " is already being used. Please choose another tag.", { color: '#FFA500' }).then((confirm) => {});
                    this.tag = this.oktag;
                };
                if (arr[1] === "0") {
                    firebase.database().ref('usercore/' + this.$store.state.user.uid + '/Tag').set(this.tag);
                    this.oktag = this.tag;
                }
            }
        },
        computed: {
        }
    }
</script>

<style scoped>
    .tile {
        margin: 0px;
        padding: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        border-color: black;
        background: #FFD375;
    }

        .tile:hover {
            background: #FFA500;
        }

        .tile:active {
            background: #FFD375;
        }

    .registeredtile {
        margin: 0px;
        padding: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        border-color: black;
        background: #86F499;
    }

        .registeredtile:hover {
            background: #FFA500;
        }

        .registeredtile:active {
            background: #FFD375;
        }

    .unregisteredtile {
        margin: 0px;
        padding: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        border-color: black;
        background: #F49C86;
    }

        .unregisteredtile:hover {
            background: #FFA500;
        }

        .unregisteredtile:active {
            background: #FFD375;
        }
    .selectedtile {
        margin: 0px;
        padding: 10px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        background: #FFA500;
    }

    .bckgrnd {
        background: #FFD375;
    }

    .boldtext{
        color:black;
        font-size:large;
        font-weight:bold;
    }

    .smalltext{
        color:darkslategray;
        font-size:small;
        margin-top:4px;
    }
</style>

